import React, { useContext, useState } from 'react'
import GlobalContext from '../../../../contexts/globalContext';
import { acceptCAC, getToken } from '../../../../services/mentoriaService';
import Button from '../../../atoms/button/button';
import MentoriaModal from '../mentoria-modal/mentoriaModal';
import './mentoriaCac.scss';

interface MentoriaCacProps {
    clickCallback: any
}

const MentoriaCac = (props: MentoriaCacProps) => {

    const [showModal, setShowModal] = useState(false);
    const Context = useContext(GlobalContext);

    const handleContinue = () => {
        setShowModal(false);
        props.clickCallback();
    }

    const handleClickYes = async () => {
        setShowModal(true);
        try {
            let token;
            if (!Context.gigyaContext.gigyaAccount) {
                return;
            }

            token = await getToken(Context.gigyaContext.gigyaAccount.UID);

            await acceptCAC(token).catch(error => console.error(error))

        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="mentoria-cac">
            <h2 className="mentoria-cac__title">¡Cumples con los requisitos para hacer parte de Camino a mi casa!</h2>
            <p className="mentoria-cac__subtitle">Camino a mi casa es un programa de acompañamiento que busca acercar a las familias para que logren cumplir su propósito de tener una vivienda propia.</p>
            <div className="mentoria-cac__video">
                <iframe width={560} height={315} src="https://www.youtube.com/embed/lxBLnEwJEKo" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
            <section className="mentoria-cac__menu">
                <div className="mentoria-cac__menu__info">
                    <h2 className="mentoria-cac__menu__info__title">¿Quieres hacer parte de Camino a mi casa?</h2>
                    <div className="mentoria-cac__menu__info__buttons">
                        <Button text="NO" classname='mentoria-cac__menu__info__buttons__button' isDisabled={false} type="button" onClickAction={props.clickCallback} />
                        <Button text="SÍ" classname='mentoria-cac__menu__info__buttons__button' isDisabled={false} type="button" onClickAction={handleClickYes} />
                    </div>
                </div>
                <img className="mentoria-cac__menu__image" src="//images.ctfassets.net/gkhyeghj07ak/3PRQUUS2eBMDzjg5ht9AhK/dcb8c73c84d078f86accb5a52f0efc5d/Programaci__n.png?w=768&fm=png&fl=png8&q=75" alt="" />
            </section>
            <MentoriaModal open={showModal} handleClose={handleContinue}>
                <div className='mentoria-cac__modal-content'>
                    <h2 className='mentoria-cac__modal-content__title'>¡Bienvenido!</h2>
                    <p className='mentoria-cac__modal-content__text'>Pronto te llegará una invitación, a tu correo electrónico, a una charla donde te contaremos más de este programa.</p>
                    <Button text='Continuar' classname='mentoria-cac__modal-content__button' type='button' isDisabled={false} onClickAction={handleContinue} gtmMark="secondary" />
                </div>
            </MentoriaModal>
        </div>
    )
}

export default MentoriaCac;